import { render, staticRenderFns } from "./ZakladniInformace.vue?vue&type=template&id=7c53821c&"
import script from "./ZakladniInformace.vue?vue&type=script&lang=ts&"
export * from "./ZakladniInformace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports